import React, { useEffect, useContext } from "react";
import LanguageContext from "context/context-language";
import { Col, Row } from "reactstrap";
import MediaQuery from 'react-responsive';

let textos = {
    es: {
        seccion1: [
            "Gestión eficiente para proyectos modernos",
            "Optimiza la administración de tus  servicios con datos reales",
            "Cada vez más desarrollos, desde torres residenciales hasta centros comerciales, adoptan sistemas de submedición inteligente para tener mayor control operativo.",
            "Nuestra plataforma IoT permite conocer  de forma precisa el consumo de agua, gas y energía eléctrica de cada uno de tus servicios",
        ],
        seccion2: [
            "Tecnología IoT confiable y escalable",
            "Integra medidores inteligentes en una sola plataforma",
            [
                "Conectamos medidores de agua, gas y energía eléctrica  a un sistema centralizado que entrega información en tiempo real",
                "Visualiza consumos, detecta anomalías y genera reportes para una gestión transparente y rentable."
            ]
        ],
        seccion3: [
            "Información que impulsa decisiones",
            [
                {
                    texto: "Datos de consumo precisos para una administración eficiente",
                    img: require("../assets/img/servicios/submediciones/sub1.png")
                },
                {
                    texto: "Nuestra solución facilita la facturación interna, la detección temprana de anomalías y el control personalizado de cada servicio.",
                    img: require("../assets/img/servicios/submediciones/sub2.png")
                },
                {
                    texto: "Mejora tu administración, toma decisiones informadas y optimiza la rentabilidad de tu desarrollo.",
                    img: require("../assets/img/servicios/submediciones/sub3.png")
                },
            ]
        ],
        seccion4: [
            "Solución integral SOFTEL",
            "Diseñado para adaptarse a tus necesidades",
            [
                "SOFTEL simplifica la implementación de la submedición en cualquier tipo de proyecto, impulsando la adopción de tecnología IoT confiable y compatible con medidores de nueva generación."
            ]
        ]
    },
    en: {
        seccion1: [
            "Efficient Management for Modern Projects",
            "Optimize your service administration with real data",
            "More and more developments — from residential towers to shopping centers — are adopting smart submetering systems to gain greater operational control.",
            "Our IoT platform provides precise insights into water, gas and electricity consumption for each of your services.",
        ],
        seccion2: [
            "Reliable and Scalable IoT Technology ",
            "Integrate smart meters into a single platform",
            [
                "We connect water, gas and electricity meters to a centralized system that delivers real-time information.",
                "Monitor consumption, detect anomalies, and generate reports for transparent and profitable management."
            ]
        ],
        seccion3: [
            "Information that Drives Decisions",
            [
                {
                    texto: "Accurate consumption data for efficient administration",
                    img: require("../assets/img/servicios/submediciones/sub1.png")
                },
                {
                    texto: "Our solution streamlines internal billing, enables early anomaly detection, and allows personalized control of each service.",
                    img: require("../assets/img/servicios/submediciones/sub2.png")
                },
                {
                    texto: "Enhance your management, make informed decisions, and optimize your project’s profitability.",
                    img: require("../assets/img/servicios/submediciones/sub3.png")
                },
            ]
        ],
        seccion4: [
            "SOFTEL Integrated Solution",
            "Designed to adapt to your needs",
            [
                "SOFTEL simplifies the implementation of submetering in any type of project, promoting the adoption of reliable IoT technology compatible with next-generation meters."
            ]
        ]
    }
}

let iconos = [
    require("../assets/img/servicios/submediciones/sub-icono-01.png"),
    require("../assets/img/servicios/submediciones/sub-icono-02.png")
]
function Submediciones() {
    const { language } = useContext(LanguageContext);
    let info = textos[language];

    return (
        <div

        >
            <div className="card-detalle card-detalle-s">
                
                <div className='text1'>
                    <div>
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#4D4D4D', fontSize: '20px', marginBottom: '20px' }}>{info.seccion1[0]}</div>
                        <div style={{ background: 'transparent', fontWeight: 'normal', color: '#004A88', fontSize: '15px', marginBottom: '20px', fontWeight: 'bold' }}><i>{info.seccion1[1]}</i></div>

                        <li style={{ fontSize: '15px', color: '#63656A', listStyle: 'square', borderTop: 'solid 1px #63656A', paddingTop: '20px', listStyle: ' none', }}>
                            {info.seccion1[2]} <br /> <br />
                            {info.seccion1[3]}
                        </li>
                    </div>
                </div>
                <MediaQuery maxWidth={768}><br /><br /><br /><br /></MediaQuery>
                <div className='img1 im1-s'>
                    <div
                        className="img-detalle"
                        style={{
                            backgroundImage: `url(${require("assets/img/servicios/submediciones/submedicion.png")})`,
                        }}
                    ></div>
                </div>
            </div>
            <div className="card-detalle card-detalle-s">
                <MediaQuery minWidth={769}>
                    <div className='img1 im1-s'>
                        <div
                            className="img-detalle"
                            style={{
                                backgroundImage: `url(${require("assets/img/servicios/submediciones/submedicion-img-02.png")})`,
                            }}
                        ></div>
                    </div>
                </MediaQuery>

                <div className='text1'>
                    <div
                        style={{paddingLeft: '30px'}}
                    >
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#4D4D4D', fontSize: '20px', marginBottom: '20px' }}>{info.seccion2[0]}</div>
                        <div style={{ background: 'transparent', fontWeight: 'normal', color: '#004A88', fontSize: '15px', marginBottom: '20px', fontWeight: 'bold' }}><i>{info.seccion2[1]}</i></div>

                        <div>
                            {
                                info.seccion2[2].map((item, index) => {
                                    return (
                                        <>
                                            <li style={{ fontSize: '15px', color: '#63656A', listStyle: 'square', borderTop: 'solid 1px #63656A', padding: '20px 0 20px 0', listStyle: ' none', }}>
                                                <tbale>
                                                    <tr>
                                                        <td><img src={iconos[index]} style={{ marginRight: '20px', width: '25px' }} /></td>
                                                        <td>{item}</td>
                                                    </tr>
                                                </tbale>
                                                    
                                            </li>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <MediaQuery maxWidth={768}>
                    <br/><br/><br/>
                    <div className='img1 im1-s'>
                        <div
                            className="img-detalle"
                            style={{
                                backgroundImage: `url(${require("assets/img/servicios/submediciones/submedicion-img-02.png")})`,
                            }}
                        ></div>
                    </div>
                </MediaQuery>
            </div>
            <div
                className="card-detalle card-detalle-s"
                style={{
                    minHeight: '500px'
                }}
            >
                <div style={{ width: '100%', textAlign: 'center' }}>
                    <div style={{ background: 'transparent', fontWeight: 'bold', color: '#4D4D4D', fontSize: '20px', marginBottom: '20px' }}>{info.seccion3[0]}</div>
                    <div style={{ width: '100%' }}>
                        <Row>
                            {
                                info.seccion3[1].map((item, index) => {
                                    return (
                                        <Col lg={4} md={4} sm={12} xs={12}
                                            style={{ background: "#fff", borderRadius: '40px', minHeight: '280px', padding: '20px', border: "solid 10px #DDDDDD" }}
                                        >
                                            <img src={item.img} style={{ width: '100px', marginBottom: '30px' }} /> <br />
                                            <span style={{ color: "#63656A" }}>{item.texto}</span>
                                        </Col>
                                    )
                                })
                            }
                        </Row>
                    </div>
                </div>
            </div>
            <div className="card-detalle card-detalle-s">
                <div className='text1'>
                    <div>
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#4D4D4D', fontSize: '20px', marginBottom: '20px' }}>{info.seccion4[0]}</div>
                        <div style={{ background: 'transparent', fontWeight: 'normal', color: '#004A88', fontSize: '15px', marginBottom: '20px', fontWeight: 'bold'}}><i>{info.seccion4[1]}</i></div>

                        <li style={{ fontSize: '15px', color: '#63656A', listStyle: 'square', borderTop: 'solid 1px #63656A', paddingTop: '20px', listStyle: ' none', }}>
                            {info.seccion4[2][0]}
                        </li>

                    </div>
                </div>
                <MediaQuery maxWidth={768}><br/><br/><br/><br/></MediaQuery>
                <div className='img1 im1-s'>
                    <div
                        className="img-detalle"
                        style={{
                            backgroundImage: `url(${require("assets/img/servicios/submediciones/submedicion-img-03.png")})`,
                        }}
                    ></div>
                </div>
            </div>
        </div>
    )
}

export default Submediciones